export default __webpack_public_path__ + "static/media/coi-expirience-laptop.7ad613fe.png";